export function cobrancaEstaNaValidade(cobranca) {
  const validadeFormatada = cobranca.ValidadeFormatada;
  const dataSeparada = validadeFormatada.split('/');
  const dataDaValidade = new Date(dataSeparada[2], dataSeparada[1] - 1, dataSeparada[0]);
  const hoje = new Date();

  return hoje.setHours(0, 0, 0, 0) <= dataDaValidade.setHours(0, 0, 0, 0);
}

export default { cobrancaEstaNaValidade };
